import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { useTheme } from '../../../contexts/ThemeContext';
import { useUser } from '../../auth/AuthPage/UserContext';
import Icon from '../Icon/Icon';

function Footer() {
    const { theme, toggleTheme } = useTheme();
    // Logged in, dark mode lives in the profile menu
    const { user } = useUser();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Brand Section */}
                <div className="footer-brand">
                    <div className="footer-logo-container">
                        <img
                            src="/assets/Logo.png"
                            alt="Trade Spot Logo"
                            className={`footer-logo ${theme === 'light' ? 'logo-visible' : 'logo-hidden'}`}
                        />
                        <img
                            src="/assets/LogoWhite.png"
                            alt="Trade Spot Logo"
                            className={`footer-logo footer-logo-white ${theme === 'dark' ? 'logo-visible' : 'logo-hidden'}`}
                        />
                    </div>
                    <p className="footer-tagline">
                        Trade cards with confidence: verified middlemen, documented trades.
                    </p>
                </div>

                {/* Contact + Legal is all a footer needs - the site's
                    real navigation lives in the navbar */}
                <div className="footer-section">
                    <h4 className="footer-title">Contact</h4>
                    <ul className="footer-links">
                        <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
                    </ul>
                </div>

                <div className="footer-section">
                    <h4 className="footer-title">Legal</h4>
                    <ul className="footer-links">
                        <li><Link to="/terms" className="footer-link">Terms of Service</Link></li>
                        <li><Link to="/privacy" className="footer-link">Privacy Policy</Link></li>
                        <li><Link to="/credits" className="footer-link">Credits & Attribution</Link></li>
                    </ul>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="footer-bottom">
                <div className="footer-bottom-container">
                    <div className="footer-copyright">
                        <p>
                            © {currentYear} Trade Spot. Unofficial Fan Content permitted under the Wizards of
                            the Coast Fan Content Policy. Not approved or endorsed by Wizards. Not affiliated
                            with The Pokémon Company.
                        </p>
                        <p className="footer-fineprint">
                            Card images courtesy of Scryfall. Prices are estimates from public market data,
                            not offers to buy or sell. Map data © OpenStreetMap contributors.
                        </p>
                    </div>
                    {!user && (
                        <button
                            className="theme-toggle"
                            onClick={toggleTheme}
                            aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
                        >
                            <span className="theme-toggle-icon">
                                <Icon name={theme === 'light' ? 'moon' : 'sun'} size={18} />
                            </span>
                        </button>
                    )}
                </div>
            </div>
        </footer>
    );
}

export default Footer;
